import React from 'react';
import { string, func, shape, bool } from 'prop-types';
import cn from 'classnames';
import i18next from 'i18next';

import Text from '~components/Text';

import { DEFAULT_ICON } from './constants';
import styles from './styles.module.scss';

const Address = ({ icon, onClick, data, className, selectedAddressId, isRadio }) => {
  function handleClick() {
    onClick({ addressData: data });
  }

  return isRadio ? (
    <div className="row full-width middle space-between m-top-2 m-bottom-2">
      <button
        name={name}
        type="button"
        onClick={handleClick}
        className={cn('row middle', styles.buttonContainer)}>
        <div className={cn(styles.checkmark, 'm-right-3')} />
        <span
          className={cn(styles.label, {
            light: !data?.id === selectedAddressId,
            bold: data?.id === selectedAddressId
          })}>
          <Text className={`text-base text-dusty-gray text-truncate ${styles.textAddress}`}>
            {data.textAddress}
          </Text>
        </span>
      </button>
    </div>
  ) : (
    <button
      type="button"
      onClick={handleClick}
      className={cn('row middle m-bottom-2', styles.container, className, {
        [styles.active]: data?.id === selectedAddressId
      })}>
      <i className={`${icon || DEFAULT_ICON} m-right-2 ${styles.icon}`} />
      {icon && <span className={`${styles.kind} m-right-1`}>{i18next.t(`Address:${data.kind}`)} - </span>}
      <div className={`column start middle ${styles.textContainer}`}>
        {data.textAddress && (
          <Text className={`text-base text-dusty-gray text-truncate ${styles.textAddress}`}>
            {data.textAddress}
          </Text>
        )}
      </div>
    </button>
  );
};

Address.propTypes = {
  onClick: func.isRequired,
  className: string,
  data: shape({
    kind: string,
    textAddress: string
  }),
  icon: string,
  isRadio: bool,
  selectedAddressId: string
};

export default Address;
